import { OuterQuotes } from "./quotes";

export const TheEye = {
  displayName: "The Eye",
  possessiveName: "The Eye's",
  quotes: OuterQuotes.theEye,
  symbol: "⊚",
  get isUnlocked() {
    return true;
  }
};